
<template>
  <div>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <v-layout>
            <v-flex xs1>
              <h6 class="white--text">Anular Facturas</h6>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field label="Codigo" v-model="codigotabulacion"
                            dark
                             >
              </v-text-field>
            </v-flex>
            <v-flex mt-3>
               <v-btn  dark  class="print blue darken-4" @click="buscar">
              Buscar</v-btn>
            </v-flex>
            <v-flex mt-3>
              <v-btn  dark  class="print blue darken-4" @click="activo=!activo" v-if="!activo">
              Scanear</v-btn>
               <v-btn  dark  class="print blue darken-4" @click="activo=!activo" v-if="activo">
              Cerrar</v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6>
              <StreamBarcodeReader
                v-if="activo"
                  name="codigo"
                  @decode="onDecode"
                  @loaded="onLoaded"
              ></StreamBarcodeReader>
            </v-flex>
          </v-layout>

        </v-card-title>
        <v-card-text>
                      <v-container>
                        <layout>
                          <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th>Cliente</th>
                <th>Fecha</th>
                <th>Total</th>
              </tr>
            <tbody>
              <tr v-for="factura in facturas.results">

                <td>
                  <v-btn icon class="blue--text text--darken-2" @click="editarfactura(factura)">
                    <v-icon>cancel</v-icon>
                  </v-btn></td>
                <td class="text-xs-center">{{factura.cliente_name}}</td>
                <td class="text-xs-center">{{factura.fecha | formatDate}}</td>
                <td class="text-xs-center">Q. {{factura.total.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
          </v-flex>
                        </layout>
            <v-layout row justify-center align-center>
             <v-btn fab dark small primary @click="prev(facturas.previous)" v-if="facturas.previous">
              <v-icon dark>skip_previous</v-icon>
            </v-btn>
             <v-btn fab dark small primary @click="next(facturas.next)" v-if="facturas.next">
            <v-icon>skip_next</v-icon>
          </v-btn>
          </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-layout row justify-center>
  </v-layout>
 </div>
</template>

<script>
  import { StreamBarcodeReader } from 'vue-barcode-reader'
  export default{
    components: {StreamBarcodeReader},
    created () {
      this.$store.dispatch('actualizarfacturas', {search: 'jkdfjkajflkajfklajklfdajfklajf'})
    },
    data () {
      return {
        auto_name: '',
        buscador: '',
        activo: '',
        codigotabulacion: ''
      }
    },
    methods: {
      onDecode: function (result) {
        this.codigotabulacion = result
        this.$store.dispatch('actualizarfacturas', {search: result, ordering: '-fecha'})
        this.activo = false
      },
      onLoaded: function (result) {
      },
      buscar: function () {
        this.$store.dispatch('actualizarfacturas', {ordering: '-fecha', search: this.codigotabulacion})
      },
      next: function (dato) {
        this.$store.dispatch('actualizarfacturas2', dato)
      },
      prev: function (dato) {
        this.$store.dispatch('actualizarfacturas2', dato)
      },
      editarfactura: function (factura) {
        this.$store.commit('resetfactura')
        this.$store.commit('actualizarfactura', factura)
        this.$store.commit('actualizarestadofactura', true)
        this.$store.dispatch('getcliente', factura.cliente)
        factura.lineas.map(linea => {
          this.$store.commit('actualizarlinea', linea)
        })
        this.$router.push('anularfactura')
      }
    },
    computed: {
      facturas: function () {
        return this.$store.getters.listadofacturas
      }
    }
  }
</script>




// WEBPACK FOOTER //
// AnularFacturas.vue?6251d83c